import request from '../request'
export default {
  // 订单查询
  listOrder: function (param) {
    return request.Post('shop/listOrder', {
      orderStatus: param.orderStatus || '',
      id: param.id,
      orderNo: param.orderNo
    })
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  cleanHistoryGoodsName (parameter) {
    return request.Post('shop/cleanHistoryGoodsName', {})
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  selectGoodsCheckHotConfig () {
    return request.Post('shop/goodsCheckHotConfig')
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  shopGetById: function (param) {
    return request.Post('shop/getById', {
      id: param
    })
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  goods: function (param, pagingData) {
    return request.Post('shop/goods', {
      goodsName: param.goodsName
    }, {
      currentPage: pagingData.currentPage || '',
      pageSize: pagingData.pageSize || ''
    })
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  // 商品分类以及商品列表
  pageCategory: function (param) {
    return request.Post('shop/listCategoryBySh', param)
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  updateOrderItemByShz: function (param) {
    return request.Post('shop/updateOrderItemByShz', param)
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  updateOrderItemByYsh: function (param) {
    return request.Post('shop/updateOrderItemByYsh', param)
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  // 添加购物车
  addCartGoods: function (param) {
    return request.Post('shop/addCartGoods', {
      goodsId: param.id || '',
      category: param.category || '',
      qty: param.qty || '',
      imgPath: param.goodsImg,
      goodsName: param.goodsName,
      price: param.price
    })
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  // 购物车内点击加减按钮改变数量
  // {goodsId:商品ID,opFlag(标记 -- 1-加,2-减),category:类别ID}
  changeCartGoodsNum: function (param) {
    return request.Post('shop/changeCartGoodsNum', {
      goodsId: param.goodsId || '',
      category: param.category || '',
      opFlag: param.opFlag || ''
      // qty: param.qty || ''
    })
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  // 删除购物车
  delCartGoods: function (param) {
    return request.Post('shop/delCartGoods', param)
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  shopCartList: function (param) {
    return request.Post('shop/shopCartList')
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  }
}
